import React, {useContext, useEffect, useRef, useState} from "react";
import logo from "../assets/logo_new.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import {AuthContext} from "../contexts/auth";
import cn from "classnames";
import {Dropdown, Modal} from "bootstrap";
import {askForNotificationPermission, registerPushManager} from "../webpush/webpush"
import {toast} from "react-toastify";
import {useHistory} from "react-router";
import FormInput from "./formInput";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import {FeatureContext} from "../contexts/feature";

function Navbar() {

    const features = useContext(FeatureContext);
    const [state, dispatch] = React.useContext(AuthContext);
    let history = useHistory()

    const dropdownRef = useRef();
    useEffect(() => {
        if (dropdownRef.current) {
            new Dropdown(dropdownRef.current, {});
        }
    }, [])

    // notification
    const [notificationsActive, setNotificationsActive] = useState(Notification.permission === 'granted');

    const modalRef = useRef();
    const [modalModal, setModalModal] = useState(null);
    useEffect(() => {
        setModalModal(new Modal(modalRef.current, {}))
    }, [modalRef.current])

    const notificationDisabled = () => {
        return !features.pushManager || !features.serviceWorker
    }

    const handleNotificationBtn = e => {
        e.preventDefault()
        e.stopPropagation()
        if (modalRef.current) {
            modalModal.show();
        }
    }

    const handleModalAccept = e => {
        e.preventDefault();
        e.stopPropagation();

        if (modalRef.current) {
            modalModal.hide();
        }

        askForNotificationPermission().then(p => {
            askForNotificationPermission()
            registerPushManager();
            setNotificationsActive(true)
        }).catch(err => {
            if (err.response && err.response.status) {
                setNotificationsActive(false)
                switch (err.response.status) {
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    // preferences
    const [prefNot, setPrefNot] = useState(false);
    useEffect(() => {
        setPrefNot(state.preferences.notification)
    }, [state.preferences.notification])


    const preferencesModalRef = useRef();
    const [prefModal, setPrefModal] = useState(null);
    useEffect(() => {
        setPrefModal(new Modal(preferencesModalRef.current, {}))
    }, [preferencesModalRef.current])

    const handlePreferencesModalOpen = e => {
        e.preventDefault()
        e.stopPropagation()
        if (preferencesModalRef.current) {
            prefModal.show();
        }
    }

    const handlePrefSave = e => {
        e.preventDefault()
        e.stopPropagation()

        axios({
            method: "post",
            url: Endpoints.CHANGE_USER_PREF,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                notification: prefNot
            }
        }).then(res => {
            prefModal.hide()

            dispatch({
                type: "change_preferences", payload: {
                    preferences: {
                        notification: prefNot
                    },
                }
            })

        }).catch(err => {
            prefModal.hide()
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    // username change
    const [validated, setVaildated] = useState(false)
    const [changeUsername, setChangeUsername] = useState("")

    const usernameFormRef = useRef();
    const usernameModalRef = useRef();

    const [usernameModal, setUsernameModal] = useState(null);
    useEffect(() => {
        setUsernameModal(new Modal(usernameModalRef.current, {}))
    }, [usernameModalRef.current])

    const handleUsernameModalOpen = e => {
        e.preventDefault()
        e.stopPropagation()
        if (usernameModalRef.current) {
            usernameModal.show();
        }
    }

    const handleUsernameModalAccept = e => {
        e.preventDefault()
        e.stopPropagation()

        if (!usernameFormRef.current.checkValidity() || changeUsername.length < 2) {
            setVaildated(true);
            return;
        }

        setVaildated(false);


        axios({
            method: "patch",
            url: Endpoints.CHANGE_USER,
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                username: changeUsername
            }
        }).then(res => {
            usernameModal.hide()

            dispatch({
                type: "change_username", payload: {
                    username: changeUsername,
                }
            })

            history.go(0)
        }).catch(err => {
            usernameModal.hide()
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 404:
                        toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-3">
            <div className="container-fluid">
                <Link className="navbar-brand" to={"/"}>
                    <div className="logo">
                        <div className="">
                            <img src={logo} width={"96px"} height={"96px"} alt="Joshirando"/>
                        </div>
                    </div>
                </Link>
                <Link to={"/"} className="text-light h1 text-decoration-none">Joshirando</Link>
                <form className="d-flex" onSubmit={e => {
                    e.preventDefault()
                    e.stopPropagation()
                }}>
                    {
                        state.auth ? (
                            <div className="btn-group">
                                {
                                    !notificationsActive ? (
                                        <button
                                            type="button"
                                            className={cn(
                                                "btn btn-outline-light",
                                                {"btn-outline-danger": notificationDisabled()}
                                            )}
                                            disabled={notificationDisabled()}
                                            onClick={e => handleNotificationBtn(e)}
                                        >Benachrichtigungen aktivieren</button>
                                    ) : null
                                }
                                <div className="nav-item dropdown btn-group">
                                    <button className={cn("btn btn-outline-light dropdown-toggle")} type="button"
                                            ref={dropdownRef} data-bs-toggle="dropdown" aria-expanded="false">
                                        {state.username}
                                    </button>
                                    <ul className={cn("dropdown-menu dropdown-menu-end")}
                                        data-popper-placement="bottom-end">
                                        <li>
                                            <div className="dropdown-item"
                                                 onClick={e => handleUsernameModalOpen(e)}>Username ändern
                                            </div>
                                        </li>
                                        <li>
                                            <div className="dropdown-item"
                                                 onClick={e => handlePreferencesModalOpen(e)}>Einstellungen
                                            </div>
                                        </li>
                                        <li><Link className="dropdown-item" to={"/logout"}>Logout</Link></li>
                                    </ul>
                                </div>
                            </div>
                        ) : (
                            <Link className="btn btn-outline-light" to={"/login"}>
                                <FontAwesomeIcon icon={["fas", "sign-in-alt"]}/> Login
                            </Link>
                        )
                    }
                </form>
            </div>
            <div className="header_slop"/>

            <div className="modal" tabIndex="-1" ref={modalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Benachrichtigung</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                        </div>
                        <div className="modal-body">
                            <p>Um dir und deinen Kollegen das Leben zu erleichtern, bietet Joshirando die Möglichkeit
                                Push-Benachrichtigungen an dich zu senden. Du kannst über die Einstellungen jederzeit
                                anpassen, wo drüber du benachrichtigt werden möchtest oder Benachrichtigungen komplett
                                deaktivieren.</p>
                            <p>Wenn du dich für Benachrichtigungen entscheidest, bekommst du ein Pop-up von deinem
                                Browser mit zwei Optionen. "<b>Zulassen</b>" und "<b>Blockieren</b>". Du kannst den
                                Prozess jederzeit abbrechen, wenn du es dir nochmal überlegen möchtest. Aber klick auf
                                gar keinen Fall auf "<b>Blockieren</b>" das würde Joshirando auf eine Blockliste setzen
                                und es für dich sehr aufwendig machen, wenn du dich doch für Benachrichtigungen
                                entscheiden solltest.</p>
                            <p>Lass dir noch eins gesagt sein. Du musst Benachrichtigungen auf jedem neuen Gerät erneut
                                bestätigen.</p>
                            <p>Danke für dein Verständnis!<br/>Dein Joshirando Team</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen
                            </button>
                            <button type="button" className="btn btn-primary text-light"
                                    onClick={e => handleModalAccept(e)} data-bs-dismiss="modal">Zulassen
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal" tabIndex="-1" ref={usernameModalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Username ändern</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                        </div>
                        <div className="modal-body">
                            <p>Hier kannst du deinen Nutzernamen ändern:</p>
                            <form ref={usernameFormRef} onSubmit={e => {
                                e.preventDefault()
                                e.stopPropagation()
                            }} className={cn({"was-validated": validated})}>
                                <FormInput required type="text" minLength={2} maxLength={32}
                                           prefix={<FontAwesomeIcon className="text-primary" icon={["fas", "user"]}/>}
                                           pattern="^[\w\u00C0-\u00FF \.-]{2,32}$"
                                           setValue={setChangeUsername} value={changeUsername}
                                           placeholder={state.username}
                                           info="Gib hier bitte deinen gewünschten Nutzernamen ein."/>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen
                            </button>
                            <button type="button" className="btn btn-primary text-light"
                                    onClick={e => handleUsernameModalAccept(e)}>Speichern
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal" tabIndex="-1" ref={preferencesModalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Einstellungen</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                        </div>
                        <div className="modal-body">
                            <form ref={usernameFormRef} onSubmit={e => {
                                e.preventDefault()
                                e.stopPropagation()
                            }}>

                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" checked={prefNot}
                                           onChange={e => setPrefNot(e.target.checked)} id="flexCheckDefault"/>
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Möchtest du Benachrichtigungen erhalten?
                                    </label>
                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen
                            </button>
                            <button type="button" onClick={e => handlePrefSave(e)}
                                    className="btn btn-primary text-light">Speichern
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar